import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'MuiVideoPlayer' })(({ typography }) => ({
  icon: {
    width: typography.pxToRem(135),
    cursor: 'pointer',
    objectFit: 'contain',
    height: 'auto',
  },
  smallIcon: {
    width: typography.pxToRem(45),
    cursor: 'pointer',
    objectFit: 'contain',
    height: 'auto',
  },
  defaultVideoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: typography.pxToRem(690),
    height: typography.pxToRem(432),
  },
  playButton: {},
}));

export default useStyles;
